import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import supabase from '../../supabase/supabase';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import Button from '../../components/ui/Button';

const Dashboard = () => {
  const [stats, setStats] = useState({
    resources: 0,
    published: 0,
    subscribers: 0,
    contacts: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      const [res, sub, con] = await Promise.all([
        supabase.from('resources_1779569461628').select('*', { count: 'exact' }),
        supabase.from('newsletter_subscribers_1779580000000').select('*', { count: 'exact' }),
        supabase.from('contact_submissions_1779580000000').select('*', { count: 'exact' })
      ]);

      setStats({
        resources: res.count || 0,
        published: res.data?.filter(r => r.published).length || 0,
        subscribers: sub.count || 0,
        contacts: con.count || 0
      });
      setLoading(false);
    };

    fetchStats();
  }, []);

  const statCards = [
    { label: 'Total Resources', value: stats.resources, icon: FiIcons.FiBookOpen, color: 'brand-teal' },
    { label: 'Published Articles', value: stats.published, icon: FiIcons.FiCheckCircle, color: 'brand-teal' },
    { label: 'Newsletter Subs', value: stats.subscribers, icon: FiIcons.FiMail, color: 'brand-teal' },
    { label: 'New Enquiries', value: stats.contacts, icon: FiIcons.FiMessageSquare, color: 'brand-teal' }
  ];

  return (
    <div className="space-y-8">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-brand-navy leading-tight">Welcome back, Tomar</h1>
          <p className="text-gray-500">Here's what's happening with AI CoLab Studio.</p>
        </div>
        <Button to="/admin/resources/new" variant="primary">
          <SafeIcon icon={FiIcons.FiPlus} className="mr-2" />
          Create New Resource
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat, i) => (
          <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-brand-teal/10 rounded-xl flex items-center justify-center text-brand-teal">
                <SafeIcon icon={stat.icon} className="w-6 h-6" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500 uppercase tracking-wider">{stat.label}</p>
                <p className="text-2xl font-bold text-brand-navy">{stat.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="p-6 border-b border-gray-100 flex justify-between items-center">
            <h3 className="font-bold text-brand-navy">Recent Resources</h3>
            <Link to="/admin/resources" className="text-brand-teal text-sm font-semibold hover:underline">View All</Link>
          </div>
          <div className="divide-y divide-gray-100">
            {loading ? (
              <div className="p-8 text-center"><SafeIcon icon={FiIcons.FiLoader} className="animate-spin inline-block text-brand-teal" /></div>
            ) : stats.resources === 0 ? (
              <div className="p-8 text-center text-gray-500">No resources created yet.</div>
            ) : (
              <div className="p-4">
                <p className="text-sm text-gray-500">Resource list will appear here in the Resources tab.</p>
              </div>
            )}
          </div>
        </div>
        
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 flex flex-col items-center justify-center text-center">
          <div className="w-16 h-16 bg-brand-teal/10 rounded-full flex items-center justify-center text-brand-teal mb-4">
            <SafeIcon icon={FiIcons.FiHelpCircle} className="w-8 h-8" />
          </div>
          <h3 className="font-bold text-brand-navy mb-2">Need help managing your content?</h3>
          <p className="text-gray-600 text-sm mb-6">You can edit any existing resource or create new guides for your audience.</p>
          <Button to="/admin/resources" variant="outline">Manage Resources</Button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;